<template>
  <div>
    <div v-if="status === 2 && category" class="NoDataDv">
      <NoData :category="'coupon.gif'" />
    </div>
    <slot v-if="status === 3"></slot>
  </div>
</template>

<script>
import NoData from "@/components/NoData/NoData.vue";
export default {
  name: "Placeholder",
  props: {
    status: {
      type: Number, //1加载中，2没有内容，3正常显示内容
      default: 1
    },
    placeholderRow: {
      type: Number,
      default: 6
    },
    category: {
      type: String,
      default: ""
    }
  },
  components: { NoData }
};
</script>
<style lang="scss" scoped>
.NoDataDv {
  height: 100vh;
}
</style>
